module.exports = __webpack_public_path__ + "img/906-0bb182.png";